/* @flow */
import React from 'react';

import {
    Box,
    Stack,
    Columns,
    Column,
    Text,
    Flex,
    Divider,
    Button as NeoButton,
    Icon as NeoIcon
} from '@locus-taxy/neo-ui';
import Select from 'common/components/core/select';

export default class MoveVisitDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSalesExecutive: null,
            salesmanOptions: props.getSalesmanOptions(),
            salesmanBeatOptions: [],
            targetBeat: null
        };
    }

    onTargetBeatChange = targetBeat => {
        if (targetBeat) {
            this.setState({
                targetBeat: {
                    value: targetBeat.value,
                    label: targetBeat.label
                }
            });
        } else {
            // Value Clear case
            this.setState({
                targetBeat: null
            });
        }
    };

    onSalesmanChange = selectedSalesman => {
        if (selectedSalesman) {
            const { salesbeatPlan } = this.props;
            const { beats } = salesbeatPlan;
            const salesmanBeats = beats.filter(beat => {
                return beat.currentSalesmanId === selectedSalesman.value;
            });
            const salesmanBeatOptions = salesmanBeats.map(beat => {
                const { dayOfWeek, week } = beat.beatDay;
                return {
                    value: beat.beatId,
                    label: `${week} ${dayOfWeek} - ${beat.beatId}`
                };
            });
            this.setState({
                selectedSalesExecutive: selectedSalesman.value,
                salesmanBeatOptions
            });
        } else {
            // Value Clear case
            this.setState({
                selectedSalesExecutive: null,
                salesmanBeatOptions: [],
                targetBeat: null
            });
        }
    };

    onApplyClick = () => {
        const { onEditBeat, targetVisit, onDismiss } = this.props;
        const { targetBeat } = this.state;
        onEditBeat(targetBeat.value, targetVisit);
        onDismiss();
    };

    render() {
        const { toggleMoveVisitDialog, theme, t } = this.props;
        const {
            selectedSalesExecutive,
            salesmanOptions,
            salesmanBeatOptions,
            targetBeat
        } = this.state;
        return (
            <Box>
                <Flex flexDirection={Flex.Direction.Column}>
                    <Box height="54px" p={4}>
                        <Columns alignY="center">
                            <Column width="fluid">
                                <Text fontSize={4} fontWeight={600}>
                                    {t('fpPlanView.moveVisit')}
                                </Text>
                            </Column>
                            <NeoIcon
                                size="large"
                                icon="cross"
                                onClick={toggleMoveVisitDialog}
                            />
                        </Columns>
                    </Box>
                    <Divider color="grey.200" />
                    <Box p={4}>
                        <Stack space="small">
                            <Text fontWeight={600} fontSize={2}>
                                {t('fpPlanView.chooseSalesExecutive')}
                            </Text>
                            <Select
                                onChange={this.onSalesmanChange}
                                className={theme.salesmanSearch}
                                theme={theme}
                                options={salesmanOptions}
                                value={selectedSalesExecutive}
                                placeholder="Sales executive"
                                creatable={false}
                                isSearchable
                            />
                            <Columns alignY="center">
                                <Column width="fluid">
                                    <Text fontSize={3} fontWeight={600}>
                                        {selectedSalesExecutive}
                                    </Text>
                                </Column>
                                <Columns
                                    alignY="center"
                                    align="right"
                                    space="small"
                                >
                                    <Column width="content">
                                        <Box width={175}>
                                            <Select
                                                // HACK for clearing value when clearing salesMan will be fixing in ES-34759
                                                key={JSON.stringify(targetBeat)}
                                                onChange={
                                                    this.onTargetBeatChange
                                                }
                                                className={theme.salesmanSearch}
                                                theme={theme}
                                                options={salesmanBeatOptions}
                                                value={targetBeat?.value}
                                                placeholder={t(
                                                    'fpPlanView.selectTargetBeat'
                                                )}
                                            />
                                        </Box>
                                    </Column>
                                </Columns>
                            </Columns>
                        </Stack>
                    </Box>
                    <Box height="48px" p={2} className={theme.moveBeatFooter}>
                        <Columns align="right" alignY="center" space="small">
                            <NeoButton
                                appearance="outline"
                                palette="primary"
                                onClick={toggleMoveVisitDialog}
                            >
                                {t('fpPlanView.cancel')}
                            </NeoButton>
                            <NeoButton
                                appearance="solid"
                                palette="primary"
                                onClick={this.onApplyClick}
                                disabled={
                                    !selectedSalesExecutive || !targetBeat
                                }
                            >
                                {t('fpPlanView.apply')}
                            </NeoButton>
                        </Columns>
                    </Box>
                </Flex>
            </Box>
        );
    }
}
